/* unplugin-vue-components disabled */import script from "./AppgCircularSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./AppgCircularSpinner.vue?vue&type=script&setup=true&lang=js"

import "./AppgCircularSpinner.vue?vue&type=style&index=0&id=f2cf36aa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2cf36aa"]])

export default __exports__